export const drinksCatalog = {
  images: "imagesDrinks",
  title: "DRINKS",
  position: "right",
  catalogs: [
    {
      id: 1,
      title: "Shakes & Smoothies",
      items: [
        {
          id: 600,
          name: "Sappa-Schnee",
          des: "Lime, sweet milk, milk, sugar, ice",
          price: 6.5,
        },
        {
          id: 601,
          name: "Mango Lassi",
          des: "Mango, sweet milk, milk, sugar, ice",
          price: 6.5,
        },
        {
          id: 602,
          name: "Avocado Shake",
          des: "Avocado, sweet milk, milk, sugar, ice",
          price: 6.9,
        },
        {
          id: 603,
          name: "Erdbeer Traum",
          des: "Strawberry, sweet milk, milk, sugar, ice",
          price: 6.9,
        },
        {
          id: 604,
          name: "Banana Shake",
          des: "Fresh banana, sweet milk, milk, ice",
          price: 6.5,
        },
        {
          id: 605,
          name: "Matcha Shake",
          des: "Matcha powder, sweet milk, sugar, milk, ice",
          price: 6.9,
        },
      ],
    },
    {
      id: 2,
      title: "Soft Drinks",
      items: [
        {
          id: 606,
          name: "Oppacher Ginger Ale",
          des: "Ginger Ale 0.25L",
          price: 3.5,
        },
        { id: 607, name: "Oppacher Tonic", des: "Tonic 0.25L", price: 3.5 },
        {
          id: 608,
          name: "Oppacher Bitter Lemon",
          des: "Bitter Lemon 0.25L",
          price: 3.5,
        },
        { id: 625, name: "Pepsi", des: "Pepsi 0.2L", price: 3.3 },
        { id: 626, name: "Pepsi Large", des: "Pepsi 0.4L", price: 4.7 },
        { id: 627, name: "Mirinda", des: "Mirinda 0.2L", price: 3.3 },
        { id: 628, name: "Mirinda Large", des: "Mirinda 0.4L", price: 4.7 },
        { id: 629, name: "7 Up", des: "7 Up 0.2L", price: 3.3 },
        { id: 630, name: "7 Up Large", des: "7 Up 0.4L", price: 4.7 },
        { id: 631, name: "Spezi", des: "Spezi 0.2L", price: 3.3 },
        { id: 632, name: "Spezi Large", des: "Spezi 0.4L", price: 4.7 },
        { id: 633, name: "Pepsi Zero", des: "Pepsi Zero 0.2L", price: 3.3 },
        {
          id: 634,
          name: "Pepsi Zero Large",
          des: "Pepsi Zero 0.4L",
          price: 4.7,
        },
      ],
    },
    {
      id: 3,
      title: "Juices & Nectars",
      items: [
        { id: 609, name: "Orange Juice", des: "Orange juice 0.2L", price: 3.4 },
        { id: 610, name: "Apple Juice", des: "Apple juice 0.2L", price: 3.4 },
        { id: 611, name: "Cherry Juice", des: "Cherry juice 0.2L", price: 3.4 },
        {
          id: 612,
          name: "Banana Nectar",
          des: "Banana nectar 0.2L",
          price: 3.4,
        },
        { id: 613, name: "Mango Juice", des: "Mango juice 0.4L", price: 4.9 },
        {
          id: 614,
          name: "Aloe Vera Juice",
          des: "Aloe Vera juice 0.4L",
          price: 4.9,
        },
        {
          id: 615,
          name: "Rhubarb Juice",
          des: "Rhubarb juice 0.4L",
          price: 4.9,
        },
        {
          id: 616,
          name: "Pineapple Juice",
          des: "Pineapple juice 0.4L",
          price: 4.9,
        },
        {
          id: 617,
          name: "Fruit Spritzer Small",
          des: "Fruit spritzer 0.2L",
          price: 3.8,
        },
        {
          id: 618,
          name: "Fruit Spritzer Large",
          des: "Fruit spritzer 0.4L",
          price: 4.9,
        },
      ],
    },
    {
      id: 4,
      title: "Water",
      items: [
        {
          id: 619,
          name: "Water Still Small",
          des: "Still water 0.2L",
          price: 2.8,
        },
        {
          id: 620,
          name: "Water Still Medium",
          des: "Still water 0.4L",
          price: 3.8,
        },
        {
          id: 621,
          name: "Water Still Large",
          des: "Still water 1L",
          price: 6.5,
        },
        {
          id: 622,
          name: "Water Classic Small",
          des: "Classic water 0.2L",
          price: 2.8,
        },
        {
          id: 623,
          name: "Water Classic Medium",
          des: "Classic water 0.4L",
          price: 3.8,
        },
        {
          id: 624,
          name: "Water Classic Large",
          des: "Classic water 1L",
          price: 6.5,
        },
      ],
    },
  ],
};
export const coffeeCatalog = {
  images: "imagesCoffee",
  title: "COFFEE",
  position: "right",
  catalogs: [
    {
      id: 1,
      title: "Vietnamese Coffee",
      items: [
        {
          id: 700,
          name: "Vietnam Kaffee",
          des: "Strong, intense Vietnamese coffee",
          price: 4.5,
        },
        {
          id: 701,
          name: "Coffee with Sweet Milk",
          des: "Vietnamese coffee with sweetened milk",
          price: 4.9,
        },
        {
          id: 702,
          name: "Vietnam Iced Coffee",
          des: "Vietnamese iced coffee",
          price: 5.5,
        },
        {
          id: 703,
          name: "Coconut Coffee (Cold)",
          des: "Cold coconut coffee",
          price: 5.5,
        },
      ],
    },
    {
      id: 2,
      title: "Special Lattes",
      items: [
        {
          id: 704,
          name: "Caramel Latte",
          des: "Coffee with caramel flavor",
          price: 4.8,
        },
        {
          id: 705,
          name: "Matcha Latte",
          des: "Green tea powder, milk",
          price: 4.8,
        },
        {
          id: 706,
          name: "Latte Macchiato",
          des: "Espresso with milk foam",
          price: 4.2,
        },
      ],
    },
    {
      id: 3,
      title: "Classic Coffee",
      items: [
        {
          id: 707,
          name: "Cappuccino",
          des: "Espresso with steamed milk and foam",
          price: 4.2,
        },
        {
          id: 708,
          name: "Espresso Single",
          des: "Single shot espresso",
          price: 2.5,
        },
        {
          id: 709,
          name: "Espresso Double",
          des: "Double shot espresso",
          price: 3.8,
        },
      ],
    },
    {
      id: 4,
      title: "Chocolate Drinks",
      items: [
        {
          id: 710,
          name: "Hot Chocolate",
          des: "Rich hot chocolate",
          price: 5.2,
        },
        {
          id: 711,
          name: "Cold Chocolate",
          des: "Refreshing cold chocolate",
          price: 5.2,
        },
      ],
    },
  ],
};
export const teaCatalog = {
  images: "imagesTea",
  title: "TEA",
  position: "right",
  catalogs: [
    {
      id: 1,
      title: "Classic Teas",
      items: [
        {
          id: 800,
          name: "Jasmine Tea",
          des: "Fragrant jasmine tea",
          price: 4.5,
        },
        {
          id: 801,
          name: "Green Tea",
          des: "Traditional green tea",
          price: 4.5,
        },
      ],
    },
    {
      id: 2,
      title: "Floral & Fruity Teas",
      items: [
        {
          id: 802,
          name: "Rose Blossom Tea",
          des: "Rose blossom tea with goji berry",
          price: 5.5,
        },
        {
          id: 803,
          name: "Yuzu Tea",
          des: "Citrus fruits with honey",
          price: 5.9,
        },
      ],
    },
    {
      id: 3,
      title: "Spiced & Herbal Teas",
      items: [
        {
          id: 804,
          name: "Cinnamon Haze",
          des: "Ginger, orange, cinnamon, honey",
          price: 6.5,
        },
        {
          id: 805,
          name: "Peppermint-Ginger Tea",
          des: "Ginger, fresh mint, honey",
          price: 5.9,
        },
        {
          id: 806,
          name: "Winter Tea",
          des: "Lemongrass, ginger, lime, honey",
          price: 5.9,
        },
      ],
    },
  ],
};
export const homemadeCatalog = {
  images: "imagesHomemade",
  title: "HOMEMADE DRINKS",
  position: "right",
  catalogs: [
    {
      id: 1,
      title: "Iced Teas",
      items: [
        {
          id: 900,
          name: "Giri Eistee",
          des: "Orange, peach, lemongrass, tea, sugarsyrup",
          price: 7.5,
        },
        {
          id: 901,
          name: "Mot’s Hoian",
          des: "Lemongrass, lime, tea, honey",
          price: 7.5,
        },
        {
          id: 902,
          name: "Danang Hometown",
          des: "Blue Curaçao, lime, tea, sugarsyrup",
          price: 6.5,
        },
        {
          id: 903,
          name: "Berry Dreams",
          des: "Blueberries, lime juice, sugarsyrup, tea",
          price: 7.5,
        },
        {
          id: 904,
          name: "Lychee Eistee",
          des: "Lychee, strawberries, sugar, lime, tea",
          price: 6.9,
        },
        {
          id: 905,
          name: "Erdbeer Eistee",
          des: "Strawberries, lime, sugarsyrup, tea",
          price: 6.9,
        },
      ],
    },
    {
      id: 2,
      title: "Mojito Variations",
      items: [
        {
          id: 906,
          name: "Himbeer Mojito",
          des: "Raspberries, fresh mint, sugarsyrup, soda",
          price: 6.9,
        },
        {
          id: 907,
          name: "Virgin Mojito",
          des: "Mint, limes, sugarsyrup, soda",
          price: 6.9,
        },
        {
          id: 908,
          name: "Virgin Hugo",
          des: "Elderflower syrup, mint, lime, sugarsyrup, soda",
          price: 7.5,
        },
      ],
    },
    {
      id: 3,
      title: "Signature Blends",
      items: [
        {
          id: 909,
          name: "Hanoi Trending",
          des: "Limes, orange, ginger, mint, soda, sugar",
          price: 6.5,
        },
        {
          id: 910,
          name: "Saigon Sunshine",
          des: "Lime, lemongrass, ginger, mint, sugar, soda, ginger ale, grenadine syrup",
          price: 7.9,
        },
        {
          id: 911,
          name: "Virgin Piña Colada",
          des: "Coconut syrup, cream, pineapple juice",
          price: 7.9,
        },
      ],
    },
  ],
};
export const fusionCatalog = {
  images: "imagesFusion",
  title: "HOMEMADE & COCKTAILS",
  position: "right",
  catalogs: [
    {
      id: 1,
      title: "Alcohol-Free Homemade",
      items: [
        {
          id: 1000,
          name: "Pinky Sway",
          des: "Guava and lychee juice, soda, raspberries, fresh mint, chia seeds",
          price: 7.9,
        },
        {
          id: 1001,
          name: "Sweet Nana",
          des: "Strawberries, cream, orange juice, pineapple juice",
          price: 7.9,
        },
        {
          id: 1002,
          name: "Ginger Taste",
          des: "Fresh ginger, lime, mint, ginger ale, soda, sugarsyrup",
          price: 6.9,
        },
        {
          id: 1003,
          name: "Tropical Drink",
          des: "Mango juice, lime, strawberries, soda, sugarsyrup",
          price: 7.9,
        },
      ],
    },
    {
      id: 2,
      title: "Classic & Fusion Cocktails",
      items: [
        {
          id: 1004,
          name: "Mai Tai",
          des: "White rum, brown rum, orange, Triple Sec, lime",
          price: 8.9,
        },
        {
          id: 1005,
          name: "Tequila Sunrise",
          des: "Tequila, orange juice, grenadine",
          price: 8.9,
        },
        {
          id: 1006,
          name: "Gin Tonic",
          des: "Gin, tonic water, lemons",
          price: 8.5,
        },
      ],
    },
  ],
};
export const signatureCatalog = {
  images: "imagesSignature",
  title: "SIGNATURE DRINKS",
  position: "right",
  catalogs: [
    {
      id: 1,
      title: "Signature Cocktails",
      items: [
        {
          id: 1100,
          name: "Miss Saigon",
          des: "Cachaca, lime juice, mint, ginger, soda, lemongrass, sugar syrup",
          price: 9.9,
        },
        {
          id: 1101,
          name: "Singapore Sling",
          des: "Gin, pineapple juice, sugar syrup, cherry-brandy",
          price: 9.9,
        },
        {
          id: 1102,
          name: "Lychee Spritz",
          des: "Lychee syrup, lychee liqueur, Prosecco, lime, soda",
          price: 8.9,
        },
        {
          id: 1103,
          name: "Choya Spritz",
          des: "Choya plum wine, Prosecco, soda",
          price: 8.9,
        },
        {
          id: 1104,
          name: "Aperol Spritz",
          des: "Aperol, Prosecco, soda, orange",
          price: 8.9,
        },
        {
          id: 1105,
          name: "Sleepless Tokyo",
          des: "Choya plum wine, lime, sugar syrup, tonic water",
          price: 9.9,
        },
        {
          id: 1106,
          name: "Lillet Wild Berry",
          des: "Lillet Blanc, Schweppes Wildberry, berries",
          price: 8.9,
        },
        {
          id: 1107,
          name: "Hugo",
          des: "Elderflower syrup, Prosecco, lime, mint, soda",
          price: 8.9,
        },
        {
          id: 1108,
          name: "Mojito",
          des: "Rum, lime, mint, soda, sugar syrup",
          price: 8.9,
        },
      ],
    },
  ],
};
export const beerCatalog = {
  images: "imagesBeer",
  title: "BEER",
  position: "right",
  catalogs: [
    {
      id: 1,
      title: "Draft Beer",
      items: [
        {
          id: 1200,
          name: "Radeberger Pilsner",
          des: "German pilsner beer",
          price: 3.9,
          size: "0.3L",
        },
        {
          id: 1201,
          name: "Radeberger Pilsner",
          des: "German pilsner beer",
          price: 5.2,
          size: "0.5L",
        },
        {
          id: 1202,
          name: "Kloster Gold Hell",
          des: "Mild, full-bodied lager with fruity notes",
          price: 4.1,
          size: "0.3L",
        },
        {
          id: 1203,
          name: "Kloster Gold Hell",
          des: "Mild, full-bodied lager with fruity notes",
          price: 5.3,
          size: "0.5L",
        },
        {
          id: 1204,
          name: "Radler",
          des: "Shandy (beer with lemonade)",
          price: 3.9,
          size: "0.3L",
        },
        {
          id: 1205,
          name: "Radler",
          des: "Shandy (beer with lemonade)",
          price: 5.2,
          size: "0.5L",
        },
        {
          id: 1206,
          name: "Diesel",
          des: "Beer mixed with cola",
          price: 3.9,
          size: "0.3L",
        },
        {
          id: 1207,
          name: "Diesel",
          des: "Beer mixed with cola",
          price: 5.2,
          size: "0.5L",
        },
      ],
    },
    {
      id: 2,
      title: "Bottled Beer",
      items: [
        {
          id: 1208,
          name: "Vietnamese Beer",
          des: "Imported Vietnamese beer",
          price: 5.4,
        },
        {
          id: 1209,
          name: "Kirin Ichiban",
          des: "Japanese beer, smooth and full-bodied",
          price: 5.4,
        },
        {
          id: 1210,
          name: "Ur-Krostitzer Schwarz",
          des: "German dark beer",
          price: 5.2,
        },
        {
          id: 1211,
          name: "Schöfferhofer Hefeweizen",
          des: "Classic wheat beer",
          price: 5.4,
        },
        {
          id: 1212,
          name: "Schöfferhofer Cola Weizen",
          des: "Wheat beer with cola",
          price: 5.4,
        },
        {
          id: 1213,
          name: "Schöfferhofer Banana Weizen",
          des: "Wheat beer with banana flavor",
          price: 5.4,
        },
        {
          id: 1214,
          name: "Schöfferhofer Nonalcoholic",
          des: "Nonalcoholic wheat beer",
          price: 5.4,
        },
        {
          id: 1215,
          name: "Radeberger Nonalcoholic Pilsner",
          des: "Nonalcoholic pilsner beer",
          price: 5.4,
        },
      ],
    },
  ],
};
export const wineCatalog = {
  images: "imagesWine",
  title: "WINE",
  position: "right",
  catalogs: [
    {
      id: 1,
      title: "Sparkling Wine",
      items: [
        {
          id: 1300,
          name: "Winzer Meissen Sparkling Rosé (Nonalcoholic)",
          des: "Lively, fruity, floral and red fruit notes",
          price: 6.9,
          size: "0.2L",
        },
        {
          id: 1301,
          name: "Winzer Meissen Sparkling Rosé (Nonalcoholic)",
          des: "Lively, fruity, floral and red fruit notes",
          price: 26.0,
          size: "0.75L",
        },
        {
          id: 1302,
          name: "Villa Sandi Prosecco Il Fresco",
          des: "Fresh, light Prosecco with fine fruity nuances",
          price: 7.9,
          size: "0.2L",
        },
        {
          id: 1303,
          name: "Villa Sandi Prosecco Il Fresco",
          des: "Fresh, light Prosecco with fine fruity nuances",
          price: 29.0,
          size: "0.75L",
        },
      ],
    },
    {
      id: 2,
      title: "White Wine",
      items: [
        {
          id: 1304,
          name: "Winzer Meissen Cabernet Blanc",
          des: "Full-bodied, juicy, only 11% alcohol",
          price: 7.9,
          size: "0.2L",
        },
        {
          id: 1305,
          name: "Winzer Meissen Cabernet Blanc",
          des: "Full-bodied, juicy, only 11% alcohol",
          price: 29.0,
          size: "0.75L",
        },
        {
          id: 1306,
          name: "Winzer Meissen Scheurebe",
          des: "Light, elegant with apricot and raspberry aromas",
          price: 7.9,
          size: "0.2L",
        },
        {
          id: 1307,
          name: "Winzer Meissen Scheurebe",
          des: "Light, elegant with apricot and raspberry aromas",
          price: 29.0,
          size: "0.75L",
        },
        {
          id: 1308,
          name: "Bernhard Koch Grauburgunder",
          des: "Fresh, floral with lively bouquet and full body",
          price: 7.9,
          size: "0.2L",
        },
        {
          id: 1309,
          name: "Bernhard Koch Grauburgunder",
          des: "Fresh, floral with lively bouquet and full body",
          price: 29.0,
          size: "0.75L",
        },
        {
          id: 1310,
          name: "Weingut Wolf Riesling & Gewürztraminer",
          des: "Intense, aromatic with exotic fruit and fine sweetness",
          price: 7.9,
          size: "0.2L",
        },
        {
          id: 1311,
          name: "Weingut Wolf Riesling & Gewürztraminer",
          des: "Intense, aromatic with exotic fruit and fine sweetness",
          price: 29.0,
          size: "0.75L",
        },
      ],
    },
    {
      id: 3,
      title: "Red Wine",
      items: [
        {
          id: 1312,
          name: "Weingut Lergenmüller Spätburgunder Minerva",
          des: "Powerful Pinot Noir with berry and chocolate notes",
          price: 7.9,
          size: "0.2L",
        },
        {
          id: 1313,
          name: "Weingut Lergenmüller Spätburgunder Minerva",
          des: "Powerful Pinot Noir with berry and chocolate notes",
          price: 29.0,
          size: "0.75L",
        },
        {
          id: 1314,
          name: "Franz Leth Blauer Zweigelt",
          des: "Light, elegant with red berry and herbal aromas",
          price: 7.9,
          size: "0.2L",
        },
        {
          id: 1315,
          name: "Franz Leth Blauer Zweigelt",
          des: "Light, elegant with red berry and herbal aromas",
          price: 29.0,
          size: "0.75L",
        },
        {
          id: 1316,
          name: "Pietra Pura Primitivo Mandus",
          des: "Velvety, soft red wine with fine tannins and elegant fruit",
          price: 7.9,
          size: "0.2L",
        },
        {
          id: 1317,
          name: "Pietra Pura Primitivo Mandus",
          des: "Velvety, soft red wine with fine tannins and elegant fruit",
          price: 29.0,
          size: "0.75L",
        },
      ],
    },
  ],
};
export const wineCatalogExtra = {
  images: "imagesWineExtra",
  title: "WINE",
  position: "right",
  catalogs: [
    {
      id: 1,
      title: "Rosé Wine",
      items: [
        {
          id: 1400,
          name: "Bernhard Koch Pink Rosé",
          des: "Sparkling, aromatic rosé with light red fruit and rosehip notes",
          price: 6.9,
          size: "0.2L",
        },
        {
          id: 1401,
          name: "Bernhard Koch Pink Rosé",
          des: "Sparkling, aromatic rosé with light red fruit and rosehip notes",
          price: 26.0,
          size: "0.75L",
        },
        {
          id: 1402,
          name: "Messias Vinho Verde Rosé",
          des: "Cherry-red, aromas of sour cherries and strawberries, 10.5% alcohol",
          price: 7.9,
          size: "0.2L",
        },
        {
          id: 1403,
          name: "Messias Vinho Verde Rosé",
          des: "Cherry-red, aromas of sour cherries and strawberries, 10.5% alcohol",
          price: 29.0,
          size: "0.75L",
        },
      ],
    },
    {
      id: 2,
      title: "Dessert Wine",
      items: [
        {
          id: 1404,
          name: "Château Jany Sauternes",
          des: "Golden yellow, notes of vanilla, honey, apricot, seductive",
          price: 7.9,
          size: "0.1L",
        },
        {
          id: 1405,
          name: "Château Jany Sauternes",
          des: "Golden yellow, notes of vanilla, honey, apricot, seductive",
          price: 29.0,
          size: "0.75L",
        },
      ],
    },
    {
      id: 3,
      title: "Premium Champagne & Wine",
      items: [
        {
          id: 1406,
          name: "Champagner Legouce-Copin Brut Tradition",
          des: "Elegant, seductive champagne with complex body",
          price: 79.0,
        },
        {
          id: 1407,
          name: "Champagner Guy Larmandier Rosé Premier Cru",
          des: "Top champagne from Vertus, delicate, playful, elegant",
          price: 89.0,
        },
        {
          id: 1408,
          name: "Weingut Bercher Chardonnay",
          des: "Rich, full-bodied white wine with yellow fruit, tobacco, forest honey notes",
          price: 89.0,
        },
        {
          id: 1409,
          name: "Château Pavillon de Villenouvet Corbières",
          des: "Spicy French red wine with fine tannins, red berries, mint",
          price: 49.0,
        },
        {
          id: 1410,
          name: "Il Poggione Rosso di Montalcino",
          des: "Strong tannins, spicy aroma of leather and herbs",
          price: 59.0,
        },
      ],
    },
  ],
};
export const spiritsCatalog = {
  images: "imagesSpirits",
  title: "SPIRITS",
  position: "right",
  catalogs: [
    {
      id: 1,
      title: "Sake",
      items: [
        {
          id: 1500,
          name: "Premium Japanese Sake",
          des: "Served warm or chilled",
          price: 6.5,
          size: "0.1L",
        },
      ],
    },
    {
      id: 2,
      title: "Plum Wine & Liquor",
      items: [
        {
          id: 1501,
          name: "Choya Classic Plum Wine",
          des: "Smooth Japanese plum wine",
          price: 6.9,
          size: "0.2L",
        },
        {
          id: 1502,
          name: "Choya Classic Plum Wine",
          des: "Smooth Japanese plum wine",
          price: 23.0,
          size: "0.75L",
        },
        {
          id: 1503,
          name: "Umeshu Plum Liquor",
          des: "Japanese plum liquor",
          price: 4.9,
          size: "4CL",
        },
      ],
    },
    {
      id: 3,
      title: "Gin",
      items: [
        {
          id: 1504,
          name: "Roku Gin",
          des: "Japanese craft gin",
          price: 3.2,
          size: "2CL",
        },
        {
          id: 1505,
          name: "Roku Gin",
          des: "Japanese craft gin",
          price: 5.2,
          size: "4CL",
        },
      ],
    },
    {
      id: 4,
      title: "Spirits",
      items: [
        {
          id: 1506,
          name: "Haku",
          des: "Japanese spirit",
          price: 3.2,
          size: "2CL",
        },
        {
          id: 1507,
          name: "Haku",
          des: "Japanese spirit",
          price: 5.2,
          size: "4CL",
        },
        {
          id: 1508,
          name: "Nep Moi",
          des: "Vietnamese spirit",
          price: 3.2,
          size: "2CL",
        },
        {
          id: 1509,
          name: "Nep Moi",
          des: "Vietnamese spirit",
          price: 5.2,
          size: "4CL",
        },
      ],
    },
    {
      id: 5,
      title: "Whisky",
      items: [
        {
          id: 1510,
          name: "Suntory Hibiki Japanese Harmony 12 Years",
          des: "Premium Japanese whisky",
          price: 9.2,
          size: "Single",
        },
        {
          id: 1511,
          name: "Suntory Hibiki Japanese Harmony 12 Years",
          des: "Premium Japanese whisky",
          price: 17.5,
          size: "Double",
        },
        {
          id: 1512,
          name: "Suntory Toki Japanese Blended",
          des: "Smooth blended Japanese whisky",
          price: 7.2,
          size: "Single",
        },
        {
          id: 1513,
          name: "Suntory Toki Japanese Blended",
          des: "Smooth blended Japanese whisky",
          price: 15.5,
          size: "Double",
        },
        {
          id: 1514,
          name: "Nikka From the Barrel",
          des: "Rich Japanese whisky",
          price: 5.2,
          size: "Single",
        },
        {
          id: 1515,
          name: "Nikka From the Barrel",
          des: "Rich Japanese whisky",
          price: 9.5,
          size: "Double",
        },
      ],
    },
  ],
};
export const appetizerCatalog = {
  images: "imagesAppetizer",
  title: "APPETIZER",
  position: "right",
  catalogs: [
    {
      id: 1,
      title: "Soups",
      items: [
        {
          id: 1600,
          name: "Miso Soup",
          des: "Miso paste, seaweed, Japanese tofu, spring onions",
          price: 4.6,
        },
        {
          id: 1601,
          name: "Miso Soup with Shrimps",
          des: "Miso soup with shrimps",
          price: 5.9,
        },
        {
          id: 1602,
          name: "Miso Soup with Salmon",
          des: "Miso soup with salmon",
          price: 5.9,
        },
        {
          id: 1603,
          name: "Spicy Soup",
          des: "Mushrooms, lemongrass, basil, coconut milk",
          price: 4.0,
        },
        {
          id: 1604,
          name: "Spicy Soup with Tofu",
          des: "Spicy soup with tofu",
          price: 5.2,
        },
        {
          id: 1605,
          name: "Spicy Soup with Shrimps",
          des: "Spicy soup with shrimps",
          price: 5.9,
        },
        {
          id: 1606,
          name: "Spicy Soup with Chicken",
          des: "Spicy soup with chicken breast",
          price: 5.5,
        },
        {
          id: 1607,
          name: "Mango Soup",
          des: "Carrots, mango purée, coriander, coconut milk, chicken bouillon",
          price: 4.9,
        },
        {
          id: 1608,
          name: "Mango Soup with Tofu",
          des: "Mango soup with tofu",
          price: 5.2,
        },
        {
          id: 1609,
          name: "Mango Soup with Shrimps",
          des: "Mango soup with shrimps",
          price: 5.9,
        },
        {
          id: 1610,
          name: "Mango Soup with Chicken",
          des: "Mango soup with chicken breast",
          price: 5.5,
        },
      ],
    },
    {
      id: 2,
      title: "Edamame",
      items: [
        {
          id: 1611,
          name: "Edamame",
          des: "Steamed Japanese soy beans, sea salt",
          price: 5.5,
        },
        {
          id: 1612,
          name: "Edamame Hometown",
          des: "Roasted Japanese soybeans with butter and garlic",
          price: 6.5,
        },
      ],
    },
    {
      id: 3,
      title: "Fried Dishes",
      items: [
        {
          id: 1613,
          name: "Chicken Karaage",
          des: "Japanese crispy chicken with sweet and sour sauce",
          price: 6.5,
        },
      ],
    },
  ],
};
export const appetizerCatalogExtra = {
  images: "imagesAppetizerExtra",
  title: "APPETIZER",
  position: "right",
  catalogs: [
    {
      id: 1,
      title: "Dumplings",
      items: [
        {
          id: 1700,
          name: "Gyoza (Chicken & Veg)",
          des: "Stuffed Japanese dumplings with chicken and vegetables - finely steamed",
          price: 5.5,
        },
        {
          id: 1701,
          name: "Gyoza (Chicken & Veg)",
          des: "Stuffed Japanese dumplings with chicken and vegetables - crispy fried",
          price: 5.5,
        },
        {
          id: 1702,
          name: "Veggie Gyoza",
          des: "Stuffed Japanese dumplings with vegetables - finely steamed",
          price: 5.5,
        },
        {
          id: 1703,
          name: "Veggie Gyoza",
          des: "Stuffed Japanese dumplings with vegetables - crispy fried",
          price: 5.5,
        },
      ],
    },
    {
      id: 2,
      title: "Spring Rolls",
      items: [
        {
          id: 1704,
          name: "Ram Gion (Meat)",
          des: "Fried homemade spring rolls with glass noodles, mushrooms, vegetables, served with fish or soy sauce",
          price: 5.5,
        },
        {
          id: 1705,
          name: "Ram Gion (Tofu)",
          des: "Fried homemade spring rolls with glass noodles, mushrooms, vegetables, served with fish or soy sauce",
          price: 5.5,
        },
      ],
    },
    {
      id: 3,
      title: "Seafood",
      items: [
        {
          id: 1706,
          name: "Tom Com Ha Noi",
          des: "Giant prawns coated with green rice flakes, sweet and sour sauce",
          price: 7.9,
        },
      ],
    },
    {
      id: 4,
      title: "Grilled Skewers",
      items: [
        {
          id: 1707,
          name: "Thit Xien La Chanh (Pork Belly)",
          des: "Grilled pork belly skewer",
          price: 6.9,
        },
        {
          id: 1708,
          name: "Thit Xien La Chanh (Corn Chicken)",
          des: "Grilled corn chicken skewer",
          price: 6.9,
        },
      ],
    },
  ],
};
export const appetizerCatalogMore = {
  images: "imagesAppetizerMore",
  title: "APPETIZER",
  position: "right",
  catalogs: [
    {
      id: 1,
      title: "Fried Snacks",
      items: [
        {
          id: 1800,
          name: "Khoai Lang Chien Gion",
          des: "Sweet potato fries with homemade mayo sauce",
          price: 5.5,
        },
      ],
    },
    {
      id: 2,
      title: "Fresh Rolls",
      items: [
        {
          id: 1801,
          name: "Goi Cuon (Tofu)",
          des: "Fresh rice paper rolls with lettuce, sesame, herbs, rice noodles, tofu",
          price: 4.9,
        },
        {
          id: 1802,
          name: "Goi Cuon (Shrimps)",
          des: "Fresh rice paper rolls with lettuce, sesame, herbs, rice noodles, shrimps",
          price: 5.5,
        },
        {
          id: 1803,
          name: "Goi Cuon (Tempura Shrimps)",
          des: "Fresh rice paper rolls with lettuce, sesame, herbs, rice noodles, tempura shrimps",
          price: 6.5,
        },
        {
          id: 1804,
          name: "Goi Cuon (Chicken)",
          des: "Fresh rice paper rolls with lettuce, sesame, herbs, rice noodles, crispy chicken breast",
          price: 5.9,
        },
      ],
    },
    {
      id: 3,
      title: "Tapas",
      items: [
        {
          id: 1805,
          name: "Tapas aus Vietnam",
          des: "Various appetizers from starters menu, portion for two",
          price: 18.9,
        },
      ],
    },
  ],
};
export const saladCatalog = {
  images: "imagesSalad",
  title: "SALAD",
  position: "right",
  catalogs: [
    {
      id: 1,
      title: "Seaweed Salad",
      items: [
        {
          id: 1900,
          name: "Kuki Wakane",
          des: "Japanese seaweed salad with sesame",
          price: 5.5,
        },
      ],
    },
    {
      id: 2,
      title: "Mango Salad",
      items: [
        {
          id: 1901,
          name: "Golden Mango Salad (Tofu)",
          des: "Mango, cucumber, bell peppers, herbs, peanuts, lime vinaigrette, tofu",
          price: 5.9,
        },
        {
          id: 1902,
          name: "Golden Mango Salad (Shrimps)",
          des: "Mango, cucumber, bell peppers, herbs, peanuts, lime vinaigrette, shrimps",
          price: 6.9,
        },
        {
          id: 1903,
          name: "Golden Mango Salad (Chicken)",
          des: "Mango, cucumber, bell peppers, herbs, peanuts, lime vinaigrette, chicken breast strips",
          price: 6.5,
        },
      ],
    },
    {
      id: 3,
      title: "Papaya Salad",
      items: [
        {
          id: 1904,
          name: "Goi Du Du (Tofu)",
          des: "Papaya, carrots, cucumber, bell peppers, herbs, peanuts, lime vinaigrette, tofu",
          price: 5.9,
        },
        {
          id: 1905,
          name: "Goi Du Du (Shrimps)",
          des: "Papaya, carrots, cucumber, bell peppers, herbs, peanuts, lime vinaigrette, shrimps",
          price: 6.9,
        },
        {
          id: 1906,
          name: "Goi Du Du (Chicken)",
          des: "Papaya, carrots, cucumber, bell peppers, herbs, peanuts, lime vinaigrette, chicken breast strips",
          price: 6.5,
        },
      ],
    },
    {
      id: 4,
      title: "Pink Grapefruit Salad",
      items: [
        {
          id: 1907,
          name: "Pink Grapefruit Salad (Tofu)",
          des: "Pink grapefruit, cucumber, mango, carrots, herbs, lime vinaigrette, tofu",
          price: 5.9,
        },
        {
          id: 1908,
          name: "Pink Grapefruit Salad (Shrimps)",
          des: "Pink grapefruit, cucumber, mango, carrots, herbs, lime vinaigrette, shrimps",
          price: 6.9,
        },
        {
          id: 1909,
          name: "Pink Grapefruit Salad (Chicken)",
          des: "Pink grapefruit, cucumber, mango, carrots, herbs, lime vinaigrette, chicken breast strips",
          price: 6.5,
        },
      ],
    },
  ],
};
export const saladCatalogExtra = {
  images: "imagesSaladExtra",
  title: "SALAD",
  position: "right",
  catalogs: [
    {
      id: 1,
      title: "Giri-Style Salad",
      items: [
        {
          id: 2000,
          name: "Goi Giri (Tofu)",
          des: "Giri-style salad with mango, cucumber, bell peppers, carrots, herbs, peanuts, lime vinaigrette, tofu",
          price: 14.9,
        },
        {
          id: 2001,
          name: "Goi Giri (Duck)",
          des: "Giri-style salad with mango, cucumber, bell peppers, carrots, herbs, peanuts, lime vinaigrette, duck",
          price: 16.9,
        },
        {
          id: 2002,
          name: "Goi Giri (Beef)",
          des: "Giri-style salad with mango, cucumber, bell peppers, carrots, herbs, peanuts, lime vinaigrette, beef",
          price: 14.9,
        },
      ],
    },
    {
      id: 2,
      title: "Herb Salad",
      items: [
        {
          id: 2003,
          name: "Wild Herb Salad (Shrimps)",
          des: "Herb salad with avocado, arugula, cherry tomatoes, walnut, sesame, sesame dressing, shrimps",
          price: 14.9,
        },
        {
          id: 2004,
          name: "Wild Herb Salad (Chicken)",
          des: "Herb salad with avocado, arugula, cherry tomatoes, walnut, sesame, sesame dressing, chicken breast",
          price: 14.9,
        },
        {
          id: 2005,
          name: "Wild Herb Salad (Salmon)",
          des: "Herb salad with avocado, arugula, cherry tomatoes, walnut, sesame, sesame dressing, flamed salmon slices",
          price: 18.9,
        },
        {
          id: 2006,
          name: "Wild Herb Salad (Tuna)",
          des: "Herb salad with avocado, arugula, cherry tomatoes, walnut, sesame, sesame dressing, flamed tuna slices",
          price: 17.9,
        },
      ],
    },
  ],
};

export const noodleCatalog = {
  images: "imagesNoodle",
  title: "NOODLE SOUPS",
  position: "right",
  catalogs: [
    {
      id: 1,
      title: "Pho – Rice Noodles",
      items: [
        {
          id: 2100,
          name: "Pho with Beef",
          des: "Vietnamese rice noodle soup with beef, herbs, spring onions",
          price: 13.5,
        },
        {
          id: 2101,
          name: "Pho with Chicken",
          des: "Vietnamese rice noodle soup with chicken breast, herbs, spring onions",
          price: 12.5,
        },
      ],
    },
    {
      id: 2,
      title: "Mien – Glass Noodles",
      items: [
        {
          id: 2102,
          name: "Mien with Beef",
          des: "Glass noodle soup with beef, herbs, spring onions",
          price: 13.5,
        },
        {
          id: 2103,
          name: "Mien with Chicken",
          des: "Glass noodle soup with chicken breast, herbs, spring onions",
          price: 13.5,
        },
      ],
    },
  ],
};
export const specialtyCatalog = {
  images: "imagesSpecialty",
  title: "VIETNAMESE SPECIALTIES",
  position: "right",
  catalogs: [
    {
      id: 1,
      title: "Banh Hoi Saigon",
      items: [
        {
          id: 2200,
          name: "Banh Hoi Saigon (Tofu)",
          des: "Steamed fine rice noodles, salad mix, spring onion, peanuts, roasted onions, coriander, fish sauce, tofu",
          price: 14.9,
        },
        {
          id: 2201,
          name: "Banh Hoi Saigon (Chicken)",
          des: "Steamed fine rice noodles, salad mix, spring onion, peanuts, roasted onions, coriander, fish sauce, grilled corn chicken skewer",
          price: 16.5,
        },
        {
          id: 2202,
          name: "Banh Hoi Saigon (Shrimps)",
          des: "Steamed fine rice noodles, salad mix, spring onion, peanuts, roasted onions, coriander, fish sauce, shrimps",
          price: 17.5,
        },
        {
          id: 2203,
          name: "Banh Hoi Saigon (Pork Belly)",
          des: "Steamed fine rice noodles, salad mix, spring onion, peanuts, roasted onions, coriander, fish sauce, grilled pork skewer",
          price: 15.9,
        },
      ],
    },
    {
      id: 2,
      title: "Banh Canh",
      items: [
        {
          id: 2204,
          name: "Banh Canh (Tofu)",
          des: "Vietnamese noodle soup with mushrooms, scallions, tofu",
          price: 14.9,
        },
        {
          id: 2205,
          name: "Banh Canh (Pork)",
          des: "Vietnamese noodle soup with mushrooms, scallions, pork",
          price: 15.9,
        },
        {
          id: 2206,
          name: "Banh Canh (Shrimps)",
          des: "Vietnamese noodle soup with mushrooms, scallions, shrimps",
          price: 17.5,
        },
        {
          id: 2207,
          name: "Banh Canh (Fish Cakes)",
          des: "Vietnamese noodle soup with mushrooms, scallions, homemade fish cakes",
          price: 17.5,
        },
      ],
    },
  ],
};
export const donburiCatalog = {
  images: "imagesDonburi",
  title: "GIRI-DONBURI",
  position: "right",
  catalogs: [
    {
      id: 1,
      title: "Donburi Bowls",
      items: [
        {
          id: 2300,
          name: "Lachs Don",
          des: "Salmon, edamame, surimi, radish, cucumber, avocado, lettuce, fish roe, corn, sesame seeds, sushi rice",
          price: 14.9,
        },
        {
          id: 2301,
          name: "Tunacado Don",
          des: "Tuna, edamame, surimi, radish, cucumber, avocado, lettuce, fish roe, corn, sesame seeds, sushi rice",
          price: 14.9,
        },
        {
          id: 2302,
          name: "Unagi Don",
          des: "Grilled eel, edamame, surimi, radish, cucumber, avocado, lettuce, fish roe, corn, sesame seeds, sushi rice",
          price: 15.9,
        },
        {
          id: 2303,
          name: "Yakitori Don",
          des: "Japanese crispy chicken, edamame, cucumber, avocado, mango, sesame seeds, sushi rice",
          price: 15.9,
        },
        {
          id: 2304,
          name: "Veggie Don",
          des: "Fried tofu, edamame, cucumber, avocado, mango, sesame seeds, sushi rice, homemade sesame dressing",
          price: 14.9,
        },
      ],
    },
  ],
};
// export const mainCourseCatalog = {
//   images: "imagesMainCourse",
//   title: "MAIN COURSE",
//   position: "right",
//   catalogs: [
//     {
//       id: 1,
//       title: "Rice Dishes",
//       items: [
//         {
//           id: 2400,
//           name: "Asian Tofu",
//           des: "Rice dish with Asian tofu",
//           price: 16.9,
//         },
//         {
//           id: 2401,
//           name: "Tender Chicken Breast",
//           des: "Rice dish with tender chicken breast",
//           price: 16.9,
//         },
//         {
//           id: 2402,
//           name: "Crispy Chicken Breast",
//           des: "Rice dish with crispy chicken breast",
//           price: 17.9,
//         },
//         {
//           id: 2403,
//           name: "Crispy Duck",
//           des: "Rice dish with crispy duck",
//           price: 19.9,
//         },
//         {
//           id: 2404,
//           name: "Crispy Vegan Duck",
//           des: "Rice dish with crispy vegan duck",
//           price: 19.9,
//         },
//         {
//           id: 2405,
//           name: "Grilled Salmon",
//           des: "Rice dish with grilled salmon",
//           price: 20.9,
//         },
//         {
//           id: 2406,
//           name: "Tender Beef",
//           des: "Rice dish with tender beef",
//           price: 18.9,
//         },
//         {
//           id: 2407,
//           name: "Fresh Shrimp",
//           des: "Rice dish with fresh shrimp",
//           price: 20.9,
//         },
//       ],
//     },
//     {
//       id: 2,
//       title: "Curry Dishes",
//       items: [
//         {
//           id: 2408,
//           name: "Curry Infusion",
//           des: "Red curry in creamy coconut milk with basil and seasonal vegetables, jasmine rice",
//           price: 4.9,
//         },
//         {
//           id: 2409,
//           name: "Golden Mango",
//           des: "Seasonal vegetables in fruity mango sauce, jasmine rice",
//           price: 4.9,
//         },
//         {
//           id: 2410,
//           name: "Creamy Peanut",
//           des: "Seasonal vegetables in aromatic peanut sauce, jasmine rice",
//           price: 4.9,
//         },
//       ],
//     },
//   ],
// };
export const mainCourseCatalogExtra = {
  images: "imagesMainCourseExtra",
  title: "MAIN COURSE",
  position: "right",
  catalogs: [
    {
      id: 1,
      title: "Rice Dishes",
      items: [
        {
          id: 2500,
          name: "Asian Tofu",
          des: "Rice dish with Asian tofu",
          price: 16.9,
        },
        {
          id: 2501,
          name: "Tender Chicken Breast",
          des: "Rice dish with tender chicken breast",
          price: 16.9,
        },
        {
          id: 2502,
          name: "Crispy Chicken Breast",
          des: "Rice dish with crispy chicken breast",
          price: 17.9,
        },
        {
          id: 2503,
          name: "Crispy Duck",
          des: "Rice dish with crispy duck",
          price: 19.9,
        },
        {
          id: 2504,
          name: "Crispy Vegan Duck",
          des: "Rice dish with crispy vegan duck",
          price: 19.9,
        },
        {
          id: 2505,
          name: "Grilled Salmon",
          des: "Rice dish with grilled salmon",
          price: 20.9,
        },
        {
          id: 2506,
          name: "Tender Beef",
          des: "Rice dish with tender beef",
          price: 18.9,
        },
        {
          id: 2507,
          name: "Fresh Shrimp",
          des: "Rice dish with fresh shrimp",
          price: 20.9,
        },
      ],
    },
    {
      id: 2,
      title: "Wok Dishes",
      items: [
        {
          id: 2508,
          name: "Fire Wok",
          des: "Wok-tossed seasonal vegetables with mushrooms and bok choy, oyster sauce, jasmine rice",
          price: null,
        },
        {
          id: 2509,
          name: "Little Spicy",
          des: "Wok-fried seasonal vegetables with lemongrass, garlic, chili, jasmine rice",
          price: null,
        },
        {
          id: 2510,
          name: "Deluxe Sauce",
          des: "Wok-seared seasonal vegetables with aromatic spices, dark specialty sauce, jasmine rice",
          price: null,
        },
      ],
    },
     {
      id: 3,
      title: "Curry Dishes",
      items: [
        {
          id: 2408,
          name: "Curry Infusion",
          des: "Red curry in creamy coconut milk with basil and seasonal vegetables, jasmine rice",
          price: null,
        },
        {
          id: 2409,
          name: "Golden Mango",
          des: "Seasonal vegetables in fruity mango sauce, jasmine rice",
          price: null,
        },
        {
          id: 2410,
          name: "Creamy Peanut",
          des: "Seasonal vegetables in aromatic peanut sauce, jasmine rice",
          price: null,
        },
      ],
    },
  ],
};
export const riceNoodleCatalog = {
  images: "imagesRiceNoodle",
  title: "RICE NOODLE DISHES",
  position: "right",
  catalogs: [
    {
      id: 1,
      title: "Rice Noodle Bowls",
      items: [
        {
          id: 2600,
          name: "Asian Tofu",
          des: "Luke-warm rice noodles with pickled vegetables, salad, herbs, peanuts, fried shallots, lime vinaigrette or soy sauce, tofu with onions",
          price: 16.9,
        },
        {
          id: 2601,
          name: "Crispy Chicken Breast",
          des: "Rice noodles with crispy chicken breast",
          price: 17.9,
        },
        {
          id: 2602,
          name: "Crispy Duck",
          des: "Rice noodles with crispy duck",
          price: 19.9,
        },
        {
          id: 2603,
          name: "Crispy Vegan Duck",
          des: "Rice noodles with crispy vegan duck",
          price: 19.9,
        },
        {
          id: 2604,
          name: "Pan-Fried Salmon",
          des: "Rice noodles with pan-fried salmon pieces",
          price: 19.9,
        },
        {
          id: 2605,
          name: "Fried Beef",
          des: "Rice noodles with fried beef",
          price: 18.9,
        },
        {
          id: 2606,
          name: "Fresh Shrimp",
          des: "Rice noodles with fresh shrimp",
          price: 20.9,
        },
        {
          id: 2607,
          name: "Spring Rolls",
          des: "Rice noodles with spring rolls",
          price: 16.9,
        },
        {
          id: 2608,
          name: "Veggie Spring Rolls",
          des: "Rice noodles with veggie spring rolls",
          price: 16.9,
        },
        {
          id: 2609,
          name: "Grilled Pork Belly",
          des: "Rice noodles with grilled pork belly skewer",
          price: 16.9,
        },
      ],
    },
  ],
};
export const friedNoodleCatalog = {
  images: "imagesFriedNoodle",
  title: "FRIED NOODLES",
  position: "right",
  catalogs: [
    {
      id: 1,
      title: "Protein Options",
      items: [
        {
          id: 2700,
          name: "Asian Tofu",
          des: "Fried noodles with Asian tofu",
          price: 16.9,
        },
        {
          id: 2701,
          name: "Tender Chicken Breast",
          des: "Fried noodles with tender chicken breast",
          price: 16.9,
        },
        {
          id: 2702,
          name: "Crispy Chicken Breast",
          des: "Fried noodles with crispy chicken breast",
          price: 17.9,
        },
        {
          id: 2703,
          name: "Crispy Duck",
          des: "Fried noodles with crispy duck",
          price: 17.9,
        },
        {
          id: 2704,
          name: "Crispy Vegan Duck",
          des: "Fried noodles with crispy vegan duck",
          price: 19.9,
        },
        {
          id: 2705,
          name: "Grilled Salmon",
          des: "Fried noodles with grilled salmon",
          price: 19.9,
        },
        {
          id: 2706,
          name: "Tender Beef",
          des: "Fried noodles with tender beef",
          price: 18.9,
        },
        {
          id: 2707,
          name: "Fresh Shrimp",
          des: "Fried noodles with fresh shrimp",
          price: 20.9,
        },
      ],
    },
    {
      id: 2,
      title: "Noodle Types",
      items: [
        {
          id: 2708,
          name: "Gebratene Reisbandnudeln",
          des: "Fried rice noodles with seasonal vegetables, fried onions, scallions, peanuts, cilantro",
          price: null,
        },
        {
          id: 2709,
          name: "Gebratene Udon-Nudeln",
          des: "Fried udon noodles with seasonal vegetables, fried onions, scallions, peanuts, cilantro",
          price: null,
        },
        {
          id: 2710,
          name: "Gebratene Glasnudeln",
          des: "Fried glass noodles with seasonal vegetables, fried onions, scallions, peanuts, cilantro",
          price: null,
        },
      ],
    },
  ],
};
export const extrasCatalog = {
  images: "imagesExtras",
  title: "EXTRAS & SIDES",
  position: "right",
  catalogs: [
    {
      id: 1,
      title: "Sides & Add-ons",
      items: [
        {
          id: 2800,
          name: "Jasmine Rice",
          des: "Fragrant jasmine rice",
          price: 2.5,
        },
        {
          id: 2801,
          name: "Rice Noodles",
          des: "Rice band noodles",
          price: 2.5,
        },
        {
          id: 2802,
          name: "Udon Noodles",
          des: "Japanese udon noodles",
          price: 4.0,
        },
        { id: 2803, name: "Tofu", des: "Asian tofu", price: 7.9 },
        {
          id: 2804,
          name: "Chicken Breast",
          des: "Tender chicken breast",
          price: 7.9,
        },
        { id: 2805, name: "Duck", des: "Crispy duck", price: 9.5 },
        { id: 2806, name: "Beef", des: "Tender beef", price: 8.5 },
        { id: 2807, name: "Shrimps (6 pcs)", des: "Fresh shrimps", price: 9.0 },
        {
          id: 2808,
          name: "Tempura Shrimps (2 pcs)",
          des: "Crispy tempura shrimps",
          price: 6.0,
        },
        {
          id: 2809,
          name: "Sauce of Choice",
          des: "Curry, mango, or peanut sauce",
          price: 4.0,
        },
        {
          id: 2810,
          name: "Unagi Sauce",
          des: "Japanese eel sauce",
          price: 2.5,
        },
        {
          id: 2811,
          name: "Sushi Rice",
          des: "Seasoned sushi rice",
          price: 3.5,
        },
      ],
    },
  ],
};
export const nigiriCatalog = {
  images: "imagesNigiri",
  title: "NIGIRI",
  position: "right",
  catalogs: [
    {
      id: 1,
      title: "Nigiri Sushi",
      items: [
        { id: 2900, name: "Sake", des: "Salmon nigiri (2 pcs)", price: 4.9 },
        { id: 2901, name: "Maguro", des: "Tuna nigiri (2 pcs)", price: 5.2 },
        {
          id: 2902,
          name: "Hamachi",
          des: "Yellowtail nigiri (2 pcs)",
          price: 5.2,
        },
        {
          id: 2903,
          name: "Ebi",
          des: "Pickled prawns nigiri (2 pcs)",
          price: 4.9,
        },
        {
          id: 2904,
          name: "Unagi",
          des: "Grilled saltwater eel nigiri (2 pcs)",
          price: 5.6,
        },
        {
          id: 2905,
          name: "Avocado",
          des: "Avocado nigiri (2 pcs)",
          price: 4.5,
        },
        { id: 2906, name: "Kappa", des: "Cucumber nigiri (2 pcs)", price: 3.9 },
        {
          id: 2907,
          name: "Tamago",
          des: "Japanese omelet nigiri (2 pcs)",
          price: 4.5,
        },
        {
          id: 2908,
          name: "Aspura",
          des: "Green asparagus nigiri (2 pcs)",
          price: 4.5,
        },
        { id: 2909, name: "Kani", des: "Surimi nigiri (2 pcs)", price: 4.5 },
        {
          id: 2910,
          name: "Inari",
          des: "Tofu pouch nigiri (2 pcs)",
          price: 4.5,
        },
      ],
    },
  ],
};
export const makiCatalog = {
  images: "imagesMaki",
  title: "MAKI",
  position: "right",
  catalogs: [
    {
      id: 1,
      title: "Maki Rolls",
      items: [
        { id: 3000, name: "Sake Maki", des: "Salmon maki (8 pcs)", price: 4.8 },
        {
          id: 3001,
          name: "Sake Avocado",
          des: "Salmon & avocado maki (8 pcs)",
          price: 5.2,
        },
        {
          id: 3002,
          name: "Spicy Sake",
          des: "Spicy salmon tartare maki (8 pcs)",
          price: 5.5,
        },
        { id: 3003, name: "Tuna Maki", des: "Tuna maki (8 pcs)", price: 4.9 },
        {
          id: 3004,
          name: "Ebi Avo Maki",
          des: "Pickled prawns & avocado maki (8 pcs)",
          price: 5.2,
        },
        {
          id: 3005,
          name: "Spicy Tuna",
          des: "Spicy tuna tartare maki (8 pcs)",
          price: 5.9,
        },
        {
          id: 3006,
          name: "Hamachi Maki",
          des: "Yellowtail maki (8 pcs)",
          price: 5.9,
        },
        {
          id: 3007,
          name: "Unagi Maki",
          des: "Grilled saltwater eel maki (8 pcs)",
          price: 5.5,
        },
        {
          id: 3008,
          name: "Rucola",
          des: "Arugula & cream cheese maki (8 pcs)",
          price: 4.7,
        },
        {
          id: 3009,
          name: "Avocado Maki",
          des: "Avocado maki (8 pcs)",
          price: 4.8,
        },
        {
          id: 3010,
          name: "Kappa Maki",
          des: "Cucumber maki (8 pcs)",
          price: 4.5,
        },
        {
          id: 3011,
          name: "Aspura Maki",
          des: "Green asparagus maki (8 pcs)",
          price: 4.7,
        },
        { id: 3012, name: "Kani Maki", des: "Surimi maki (8 pcs)", price: 4.9 },
        {
          id: 3013,
          name: "Tamago Maki",
          des: "Japanese omelet maki (8 pcs)",
          price: 4.5,
        },
        { id: 3014, name: "Mango Maki", des: "Mango maki (8 pcs)", price: 4.5 },
        {
          id: 3015,
          name: "Oshinko",
          des: "Pickled radish maki (8 pcs)",
          price: 4.6,
        },
      ],
    },
  ],
};
export const futoRollCatalog = {
  images: "imagesFutoRoll",
  title: "FUTO ROLL",
  position: "right",
  catalogs: [
    {
      id: 1,
      title: "Futo Rolls",
      items: [
        {
          id: 3100,
          name: "Sumo Futo Roll",
          des: "Salmon, tuna, tobico, cucumber, avocado, cream cheese (5 pcs)",
          price: 10.9,
        },
        {
          id: 3101,
          name: "Sake Futo",
          des: "Salmon, tobico, cucumber, avocado, cream cheese (5 pcs)",
          price: 8.9,
        },
        {
          id: 3102,
          name: "Maguro Futo",
          des: "Tuna, tobico, cucumber, avocado, cream cheese (5 pcs)",
          price: 9.9,
        },
        {
          id: 3103,
          name: "Surimi Futo",
          des: "Surimi, tobico, cucumber, avocado, cream cheese (5 pcs)",
          price: 8.9,
        },
        {
          id: 3104,
          name: "Veggie Futo",
          des: "Japanese omelet, pumpkin, cucumber, avocado, sesame (5 pcs)",
          price: 8.9,
        },
      ],
    },
  ],
};
export const sushiTapasCatalog = {
  images: "imagesSushiTapas",
  title: "SUSHI TAPAS",
  position: "right",
  catalogs: [
    {
      id: 1,
      title: "Sushi Tapas",
      items: [
        {
          id: 3200,
          name: "Tuna Tataki",
          des: "Lightly grilled tuna slices, seaweed salad, avocado, chili mayo (6 pcs)",
          price: 13.9,
        },
        {
          id: 3201,
          name: "Sake Tataki",
          des: "Lightly grilled salmon slices, seaweed salad, avocado, chili mayo (6 pcs)",
          price: 12.9,
        },
        {
          id: 3202,
          name: "Gunkan Mix",
          des: "Spicy salmon and tuna tartare, wrapped with spring onion and cucumber (2 pcs)",
          price: 7.5,
        },
        {
          id: 3203,
          name: "Shizuka",
          des: "Salmon, green asparagus, chili mayo, unagi sauce, tobiko (2 pcs)",
          price: 6.9,
        },
        {
          id: 3204,
          name: "Salmon Rose",
          des: "Flambéed salmon with salmon tartare (2 pcs)",
          price: 6.9,
        },
        {
          id: 3205,
          name: "Tuna Rose",
          des: "Flambéed tuna with tuna tartare (2 pcs)",
          price: 7.5,
        },
        {
          id: 3206,
          name: "Hamachi Toro",
          des: "Flambéed Hamachi, avocado truffle cream, tobiko (2 pcs)",
          price: 7.5,
        },
        {
          id: 3207,
          name: "Honoka",
          des: "Tuna, avocado, chili mayo, unagi, tobiko (2 pcs)",
          price: 7.5,
        },
        {
          id: 3208,
          name: "Sake Tatar",
          des: "Salmon tartare on avocado, seaweed salad, chili mayo",
          price: 11.9,
        },
        {
          id: 3209,
          name: "Tuna Tatar",
          des: "Tuna tartare on avocado, seaweed salad, chili mayo",
          price: 12.9,
        },
      ],
    },
  ],
};
export const insideOutCatalog = {
  images: "imagesInsideOut",
  title: "INSIDE OUT",
  position: "right",
  catalogs: [
    {
      id: 1,
      title: "Inside Out Rolls",
      items: [
        {
          id: 3300,
          name: "Sake Roll",
          des: "Salmon, avocado, cucumber, cream cheese, sesame (8 pcs)",
          price: 7.6,
        },
        {
          id: 3301,
          name: "Maguro Roll",
          des: "Tuna, avocado, cucumber, cream cheese, sesame (8 pcs)",
          price: 7.6,
        },
        {
          id: 3302,
          name: "Hamachi Roll",
          des: "Yellowtail, avocado, cucumber, cream cheese, sesame (8 pcs)",
          price: 7.6,
        },
        {
          id: 3303,
          name: "California Roll",
          des: "Surimi, avocado, cucumber, cream cheese, tobiko (8 pcs)",
          price: 6.9,
        },
        {
          id: 3304,
          name: "Ebi Roll",
          des: "Pickled prawns, avocado, cucumber, cream cheese, sesame (8 pcs)",
          price: 7.5,
        },
        {
          id: 3305,
          name: "Ebi Tempura Roll",
          des: "Breaded shrimp, avocado, cucumber, cream cheese, chives, unagi sauce (8 pcs)",
          price: 8.9,
        },
        {
          id: 3306,
          name: "Chicken Roll",
          des: "Grilled chicken, cucumber, cream cheese, teriyaki sauce, sesame (8 pcs)",
          price: 7.9,
        },
        {
          id: 3307,
          name: "Mango Sake Roll",
          des: "Salmon, mango, cream cheese, tobiko (8 pcs)",
          price: 7.9,
        },
        {
          id: 3308,
          name: "Veggie Roll",
          des: "Avocado, cucumber, sesame (8 pcs)",
          price: 7.3,
        },
      ],
    },
  ],
};
export const specialRollCatalog = {
  images: "imagesSpecialRoll",
  title: "SPECIAL ROLLS",
  position: "right",
  catalogs: [
    {
      id: 1,
      title: "Special Rolls",
      items: [
        {
          id: 3400,
          name: "King Tiger",
          des: "Grilled salmon belly, cucumber, mango, cream cheese, wrapped in flambéed salmon (8 pcs)",
          price: 13.5,
        },
        {
          id: 3401,
          name: "Rainbow Roll",
          des: "Surimi, avocado, cucumber, cream cheese, topped with assorted fish (8 pcs)",
          price: 13.9,
        },
        {
          id: 3402,
          name: "Tsubaki Roll",
          des: "Eel, avocado, cucumber, cream cheese, wrapped in flambéed salmon, unagi sauce (8 pcs)",
          price: 14.5,
        },
        {
          id: 3403,
          name: "Dragon Fuji",
          des: "Breaded shrimp, mango, cucumber, cream cheese, wrapped in avocado (8 pcs)",
          price: 14.9,
        },
        {
          id: 3404,
          name: "Veggie Special",
          des: "Tempura green asparagus, sweet potatoes, cucumber, cream cheese, wrapped in avocado (8 pcs)",
          price: 12.9,
        },
        {
          id: 3405,
          name: "Nánami Roll",
          des: "Spicy salmon tartare, mango, cucumber, flambéed salmon, unagi sauce, chili mayo, tobiko (8 pcs)",
          price: 14.9,
        },
        {
          id: 3406,
          name: "Hikari Roll",
          des: "Spicy tuna tartare, asparagus, avocado, wrapped in flambéed tuna, unagi sauce, mild chili mayo, tobiko (8 pcs)",
          price: 13.9,
        },
        {
          id: 3407,
          name: "Chiyo Roll",
          des: "Tuna, avocado, asparagus, wrapped in smoked salmon (8 pcs)",
          price: 12.9,
        },
        {
          id: 3408,
          name: "Hamachi Fan",
          des: "Yellowtail, avocado, cucumber, wrapped with flambéed yellowtail, unagi sauce, mild chili mayo, tobiko (8 pcs)",
          price: 12.9,
        },
        {
          id: 3409,
          name: "Blue Tunacado",
          des: "Tempura green asparagus, avocado, cream cheese, wrapped with flambéed tuna, unagi sauce, mild chili mayo (8 pcs)",
          price: 13.9,
        },
        {
          id: 3410,
          name: "Geisha Amida",
          des: "Breaded shrimp, mango, cucumber, cream cheese, wrapped in eel, unagi sauce (8 pcs)",
          price: 14.9,
        },
      ],
    },
  ],
};

export const sashimiCatalog = {
  images: "imagesSashimi",
  title: "SASHIMI",
  position: "right",
  catalogs: [
    {
      id: 2,
      title: "Sashimi",
      items: [
        {
          id: 3411,
          name: "Sake Sashimi",
          des: "Norwegian salmon on a seaweed salad (6 pcs)",
          price: 14.9,
        },
        {
          id: 3412,
          name: "Maguro Sashimi",
          des: "Tuna on a seaweed salad (6 pcs)",
          price: 16.9,
        },
        {
          id: 3413,
          name: "Sake Maguro Sashimi",
          des: "Salmon & Tuna on a seaweed salad (3 pcs each)",
          price: 15.9,
        },
        {
          id: 3414,
          name: "Hamachi Sashimi",
          des: "Yellowtail on a seaweed salad (6 pcs)",
          price: 16.9,
        },
        {
          id: 3415,
          name: "Sashimi Royal",
          des: "Salmon, Tuna, Yellowtail, Shrimp on a seaweed salad (3 pcs each)",
          price: 28.9,
        },
      ],
    },
  ],
};

export const hotMiniRollCatalog = {
  images: "imagesHotMiniRoll",
  title: "HOT MINI-ROLL",
  position: "right",
  catalogs: [
    {
      id: 3,
      title: "Hot Mini-Roll",
      items: [
        {
          id: 3416,
          name: "Sake",
          des: "Salmon & cream cheese, tempura-fried baked sushi with Giri-style sauces (8 pcs)",
          price: 7.5,
        },
        {
          id: 3417,
          name: "Spicy Tuna",
          des: "Spicy tuna & spring onions, tempura-fried baked sushi with Giri-style sauces (8 pcs)",
          price: 7.9,
        },
        {
          id: 3418,
          name: "Chicken",
          des: "Grilled chicken & cream cheese, tempura-fried baked sushi with Giri-style sauces (8 pcs)",
          price: 7.5,
        },
        {
          id: 3419,
          name: "Ebi Avo",
          des: "Pickled prawns & avocado, tempura-fried baked sushi with Giri-style sauces (8 pcs)",
          price: 7.8,
        },
        {
          id: 3420,
          name: "Veggie",
          des: "Cucumber & avocado, tempura-fried baked sushi with Giri-style sauces (8 pcs)",
          price: 6.9,
        },
      ],
    },
  ],
};
export const tempuraHotBigRollCatalog = {
  images: "imagesTempuraHotBigRoll",
  title: "GIRI'S TEMPURA HOT BIG-ROLL",
  position: "right",
  catalogs: [
    {
      id: 4,
      title: "Tempura Hot Big-Roll",
      items: [
        {
          id: 3421,
          name: "Salmon Crunchy",
          des: "Salmon, avocado, cucumber, cream cheese, sesame, tempura-fried baked sushi with Giri-style sauces (10 pcs)",
          price: 13.9,
        },
        {
          id: 3422,
          name: "Tuna Crunchy",
          des: "Tuna, avocado, cucumber, cream cheese, sesame, tempura-fried baked sushi with Giri-style sauces (10 pcs)",
          price: 14.5,
        },
        {
          id: 3423,
          name: "Hamachi Crunchy",
          des: "Yellowtail, avocado, cucumber, cream cheese, sesame, tempura-fried baked sushi with Giri-style sauces (10 pcs)",
          price: 14.5,
        },
        {
          id: 3424,
          name: "Ninja Crunchy",
          des: "Pickled prawns, avocado, cucumber, cream cheese, sesame, tempura-fried baked sushi with Giri-style sauces (10 pcs)",
          price: 13.9,
        },
      ],
    },
  ],
};

export const tempuraHotBigRollCatalog2 = {
  images: "imagesTempuraHotBigRoll",
  title: "GIRI'S TEMPURA HOT BIG-ROLL",
  position: "right",
  catalogs: [
    {
      id: 5,
      title: "Tempura Hot Big-Roll (Part 2)",
      items: [
        {
          id: 3425,
          name: "Mama Chicken Roll",
          des: "Yakitori chicken, avocado, cucumber, cream cheese, sesame, tempura-fried baked sushi with Giri-style sauces (10 pcs)",
          price: 13.9,
        },
        {
          id: 3426,
          name: "Ebi Crunchy",
          des: "Breaded shrimp, avocado, cucumber, cream cheese, sesame, tempura-fried baked sushi with Giri-style sauces (10 pcs)",
          price: 14.9,
        },
        {
          id: 3427,
          name: "Hulk Roll",
          des: "Japanese omelette, avocado, cucumber, pickled pumpkin strips, cream cheese, tempura-fried baked sushi with Giri-style sauces (10 pcs)",
          price: 12.9,
        },
        {
          id: 3428,
          name: "Veggie Crunchy",
          des: "Green asparagus, cucumber, avocado, radish, cream cheese, tempura-fried baked sushi with Giri-style sauces (10 pcs)",
          price: 12.9,
        },
      ],
    },
  ],
};
export const sushiSetCatalog = {
  images: "imagesSushiSet",
  title: "SUSHI SET",
  position: "right",
  catalogs: [
    {
      id: 6,
      title: "Sushi Set",
      items: [
        {
          id: 3429,
          name: "Maki Mix",
          des: "8 pcs Sake Maki, 8 pcs Tuna Maki, 8 pcs Avocado Maki",
          price: 12.9,
        },
        {
          id: 3430,
          name: "Sake Premium",
          des: "8 pcs Sake Maki, 8 pcs Sake Roll, 2 pcs Sake Nigiri",
          price: 14.9,
        },
        {
          id: 3431,
          name: "California Mix",
          des: "8 pcs California Roll, 8 pcs Sake Mini Crunchy Roll, 2 pcs Nigiri (Sake, Tuna)",
          price: 13.9,
        },
        {
          id: 3432,
          name: "Sumo Mix",
          des: "5 pcs Sumo Futo Roll, 8 pcs Spicy Tuna Roll, 8 pcs Ebi Avo Mini Crunchy Roll, 3 pcs Nigiri (Sake, Eel, Cucumber)",
          price: 22.9,
        },
        {
          id: 3433,
          name: "Veggie Lover",
          des: "8 pcs Veggie Roll, 8 pcs Veggie Mini Crunchy Roll, 2 pcs Nigiri (Tamago, Avocado)",
          price: 13.9,
        },
        {
          id: 3434,
          name: "You & Me",
          des: "8 pcs Sake Maki, 8 pcs California Roll, 8 pcs Tuna Special Roll, 10 pcs Chicken Crunchy Roll, 4 pcs Nigiri (Tuna, Avocado), 2 pcs Sake Sashimi",
          price: 55.9,
        },
        {
          id: 3435,
          name: "Giri Family",
          des: "Surprise from the Sushi Master, 12 pcs Maki Mix, 5 pcs Futo Roll, 16 pcs Special Roll, 10 pcs Crunchy Roll, 6 pcs Nigiri, 6 pcs Sashimi (for 2 adults & 1 child)",
          price: 79.9,
        },
      ],
    },
  ],
};

export const sushiPlattenCatalog = {
  images: "imagesSushiPlatten",
  title: "SUSHI PLATTEN",
  position: "right",
  catalogs: [
    {
      id: 7,
      title: "Sushi Platten",
      items: [
        {
          id: 3436,
          name: "Platte für 1",
          des: "Daily chef-recommended sushi creations, hot and cold, artfully prepared (for 1 person)",
          price: 25.9,
        },
        {
          id: 3437,
          name: "Platte für 2",
          des: "Daily chef-recommended sushi creations, hot and cold, artfully prepared (for 2 persons)",
          price: 54.9,
        },
        {
          id: 3438,
          name: "Platte für 3",
          des: "Daily chef-recommended sushi creations, hot and cold, artfully prepared (for 3 persons)",
          price: 83.9,
        },
        {
          id: 3439,
          name: "Platte für 4",
          des: "Daily chef-recommended sushi creations, hot and cold, artfully prepared (for 4 persons)",
          price: 98.0,
        },
        {
          id: 3440,
          name: "King’s Choice - VIP Platte",
          des: "VIP plate of the house including soups, price per person",
          price: 35.0,
        },
      ],
    },
  ],
};
export const kidsDishesCatalog = {
  images: "imagesKidsDishes",
  title: "KINDERGERICHTE",
  position: "right",
  catalogs: [
    {
      id: 8,
      title: "Kid's Dishes",
      items: [
        {
          id: 3441,
          name: "Happy Kids",
          des: "Fish sticks with sweet potato fries and ketchup",
          price: 8.9,
        },
        {
          id: 3442,
          name: "Little Chicken",
          des: "Fried chicken fillet with ketchup and jasmine rice",
          price: 8.9,
        },
        {
          id: 3443,
          name: "Tofu Paradise",
          des: "Fried tofu with sweet and sour sauce and rice (vegetarian)",
          price: 7.5,
        },
        {
          id: 3444,
          name: "Ebi Lover",
          des: "4 breaded shrimp served with jasmine rice, sweet and sour sauce, and prawn crackers",
          price: 10.5,
        },
      ],
    },
  ],
};
export const dessertCatalog = {
  images: "imagesDessert",
  title: "NACHSPEISEN",
  position: "right",
  catalogs: [
    {
      id: 9,
      title: "Dessert",
      items: [
        {
          id: 3445,
          name: "Sesam Balli",
          des: "3 sesame balls with red bean filling",
          price: 5.9,
        },
        {
          id: 3446,
          name: "Mochi Set",
          des: "3 Mochi - surprise flavor",
          price: 6.5,
        },
        {
          id: 3447,
          name: "Tropical Dream",
          des: "Black sticky rice served with mango coconut cream and fresh mango",
          price: 6.5,
        },
        {
          id: 3448,
          name: "Cocos Mango Panna Cotta",
          des: "Homemade coconut milk panna cotta, served with mango puree and coconut flakes",
          price: 5.5,
        },
        {
          id: 3449,
          name: "Eisbecher",
          des: "Ice cream per scoop (Matcha, Coconut, Black Sesame)",
          price: 2.0,
        },
      ],
    },
  ],
};
